document.addEventListener("DOMContentLoaded", function() { 
var colorSwatchesLabels = document.querySelectorAll('.variant-picker__option-values .color-swatch');

  colorSwatchesLabels.forEach(function(item){
    item.addEventListener('mouseenter', function(e) {

        var colorSwatchesInfoBlock = e.target.closest(".variant-picker__option").querySelector('.ColorSwatchList-info-block');
        var colorSwatchesInfoHover = e.target.closest(".variant-picker__option").querySelector('.ColorSwatchList-info-block-hover');
      
      var valueInfo = this.getAttribute('value-info');
      if (valueInfo != '') {
        if (colorSwatchesInfoBlock != null) {
          colorSwatchesInfoBlock.classList.add('hover-show');
        }
        if (colorSwatchesInfoHover != null) {
          colorSwatchesInfoHover.innerHTML = valueInfo;
        }
      } else {
        if (colorSwatchesInfoBlock != null) {
          colorSwatchesInfoBlock.classList.remove('hover-show');
        }
        if (colorSwatchesInfoHover != null) {
          colorSwatchesInfoHover.innerHTML = '';
        }
      }
    });

    item.addEventListener('mouseleave', function(e) {
        var colorSwatchesInfoBlock = e.target.closest(".variant-picker__option").querySelector('.ColorSwatchList-info-block');
        var colorSwatchesInfoHover = e.target.closest(".variant-picker__option").querySelector('.ColorSwatchList-info-block-hover');
      
      
        if (colorSwatchesInfoBlock != null) {
          colorSwatchesInfoBlock.classList.remove('hover-show');
        }
        if (colorSwatchesInfoHover != null) {
          colorSwatchesInfoHover.innerHTML = '';
        }
    });
  });


 var defaultTab_Ingredients_Text = true;
 var defaultTab_WhatItIs_Text = true;
  
  document.addEventListener('variant:change', function(event) {
        var variant = event.detail.variant; // Gives you access to the whole variant details
    var showDefaultTab_WhatItIs_Text = true;    
    var showDefaultTab_Ingredients_Text = true;

    var customVariantsTabsContentEl = document.querySelector('.customVariantsTabsContent');
    if(customVariantsTabsContentEl) {
      
      var ingredients_tabs = customVariantsTabsContentEl.querySelectorAll('.ingredients_tab');
      if(ingredients_tabs.length) {
        ingredients_tabs.forEach(function(item,index) {
          var itemId = item.getAttribute('data-variant-id') * 1;
          if(itemId == variant.id) {
            item.classList.add('active_variant');

            var customTabsEl = document.querySelector('.vw-product-tabs-links-list');
            if(customTabsEl) {

              var tabs_menu_items = customTabsEl.querySelectorAll('.ui-tabs-anchor');
              if(tabs_menu_items.length) {
                tabs_menu_items.forEach(function (menuItem,index) {
                  var val = menuItem.innerHTML;

                  if(val == 'Ingredients') {
                    var tabId = menuItem.getAttribute('href');
					var accID = menuItem.getAttribute('href').replace("desktop", "mobile").replace("tab","accordion");

                    var tabEl = document.querySelector(tabId);
                    var accEl = document.querySelector(accID);
                    
                    if(tabEl) {
	
                      if(defaultTab_Ingredients_Text) {
                        var customDefaultTabsContentEl = document.querySelector('.ingredients_customDefaultTabsContent');
                        if(customDefaultTabsContentEl)  {
                          customDefaultTabsContentEl.innerHTML = tabEl.innerHTML;
                          defaultTab_Ingredients_Text = false;
                        }
                      }
                      tabEl.innerHTML = item.innerHTML;
                       if(accEl) {
                         accEl.innerHTML = item.innerHTML;
                       }
                      showDefaultTab_Ingredients_Text = false;
                    }
                                        
                    
                  }
                });
              }
            }

          } else {
            item.classList.remove('active_variant');
          }
        });

        
        if(showDefaultTab_Ingredients_Text) {
          var customTabsEl = document.querySelector('.vw-product-tabs-links-list');
          if(customTabsEl) {

            var tabs_menu_items = customTabsEl.querySelectorAll('.ui-tabs-anchor');
            if(tabs_menu_items.length) {
              tabs_menu_items.forEach(function (menuItem,index) {
                var val = menuItem.innerHTML;

                if(val == 'Ingredients') {
                  var tabId = menuItem.getAttribute('href');
                  var accID = menuItem.getAttribute('href').replace("desktop", "mobile").replace("tab","accordion");
                  var tabEl = document.querySelector(tabId);
                  var accEl = document.querySelector(accID);
                  if(tabEl) {
     
                    if(!defaultTab_Ingredients_Text) {
                      var customDefaultTabsContentEl = document.querySelector('.ingredients_customDefaultTabsContent');
                      if(customDefaultTabsContentEl)  {
                        tabEl.innerHTML = customDefaultTabsContentEl.innerHTML;
                        if(accEl) {
                         accEl.innerHTML = customDefaultTabsContentEl.innerHTML;
                       }
                        showDefaultTab_Ingredients_Text = false;
                        defaultTab_Ingredients_Text = true;
                      }
                    }

                  }
                }
              });
            }
          }
        }
      }
      
      
      
            
      var what_it_is_tabs = customVariantsTabsContentEl.querySelectorAll('.what_it_is_tab');
      if(what_it_is_tabs.length) {
        what_it_is_tabs.forEach(function(item,index) {
          var itemId = item.getAttribute('data-variant-id') * 1;
          if(itemId == variant.id) {
            item.classList.add('active_variant');

            var customTabsEl = document.querySelector('.vw-product-tabs-links-list');
            if(customTabsEl) {

              var tabs_menu_items = customTabsEl.querySelectorAll('.ui-tabs-anchor');
              if(tabs_menu_items.length) {
                tabs_menu_items.forEach(function (menuItem,index) {
                  var val = menuItem.innerHTML;

                  if(val == 'What it is') {
                     var tabId = menuItem.getAttribute('href');
                  var accID = menuItem.getAttribute('href').replace("desktop", "mobile").replace("tab","accordion");
                  var tabEl = document.querySelector(tabId);
                  var accEl = document.querySelector(accID);


                    if(tabEl) {

                      if(defaultTab_WhatItIs_Text) {
                        var customDefaultTabsContentEl = document.querySelector('.what_it_is_customDefaultTabsContent');
                        if(customDefaultTabsContentEl)  {
                          customDefaultTabsContentEl.innerHTML = tabEl.innerHTML;
                          defaultTab_WhatItIs_Text = false;
                        }
                      }
                      tabEl.innerHTML = item.innerHTML;
                       if(accEl) {
                         accEl.innerHTML = item.innerHTML;
                       }
                      showDefaultTab_WhatItIs_Text = false;
                    }
                  }
                });
              }
            }

          } else {
            item.classList.remove('active_variant');
          }
        });

        
        if(showDefaultTab_WhatItIs_Text) {
          var customTabsEl = document.querySelector('.vw-product-tabs-links-list');
          if(customTabsEl) {

            var tabs_menu_items = customTabsEl.querySelectorAll('.ui-tabs-anchor');
            if(tabs_menu_items.length) {
              tabs_menu_items.forEach(function (menuItem,index) {
                var val = menuItem.innerHTML;

                if(val == 'What it is') {
                  var tabId = menuItem.getAttribute('href');
                  var accID = menuItem.getAttribute('href').replace("desktop", "mobile").replace("tab","accordion");
                  var tabEl = document.querySelector(tabId);
                  var accEl = document.querySelector(accID);
                  if(tabEl) {
                    
                    if(!defaultTab_WhatItIs_Text) {
                      var customDefaultTabsContentEl = document.querySelector('.what_it_is_customDefaultTabsContent');
                      if(customDefaultTabsContentEl)  {
                        tabEl.innerHTML = customDefaultTabsContentEl.innerHTML;
                        if(accEl) {
                         accEl.innerHTML = customDefaultTabsContentEl.innerHTML;
                       }
                        showDefaultTab_WhatItIs_Text = false;
                        defaultTab_WhatItIs_Text = true;
                      }
                    }

                  }
                }
              });
            }
          }
        }
      }
      
    }
  });

  var customVariantsTabsContentEl = document.querySelector('.customVariantsTabsContent');
  if(customVariantsTabsContentEl) {
    var isActiveCustomTab_Ingredients_El = customVariantsTabsContentEl.querySelector('.ingredients_tab.active_variant');
    var isActiveCustomTab_WhatItIs_El = customVariantsTabsContentEl.querySelector('.what_it_is_tab.active_variant');

    
    if(isActiveCustomTab_Ingredients_El || isActiveCustomTab_WhatItIs_El) {
    var timerId = setInterval(function () {
      var customTabsEl = document.querySelector('.vw-product-tabs-links-list');
      if(customTabsEl) {

        var tabs_menu_items = customTabsEl.querySelectorAll('.ui-tabs-anchor');
        if(tabs_menu_items.length) {
          tabs_menu_items.forEach(function (item,index) {
            var val = item.innerHTML;

            if(val == 'Ingredients' && isActiveCustomTab_Ingredients_El ) {
              var tabId = item.getAttribute('href');
              var accID = item.getAttribute('href').replace("desktop", "mobile").replace("tab","accordion");
              var tabEl = document.querySelector(tabId);
              var accEl = document.querySelector(accID);

              if(tabEl) {

                var customDefaultTabsContentEl = document.querySelector('.ingredients_customDefaultTabsContent');
                if(customDefaultTabsContentEl)  {
                  customDefaultTabsContentEl.innerHTML = tabEl.innerHTML;
                }
                tabEl.innerHTML = isActiveCustomTab_Ingredients_El.innerHTML;
                 if(accEl) {
                         accEl.innerHTML = isActiveCustomTab_Ingredients_El.innerHTML;
                       }
                
                defaultTab_Ingredients_Text = false;
              }
            } else if(val == 'What it is' && isActiveCustomTab_WhatItIs_El ) {
               var tabId = item.getAttribute('href');
              var accID = item.getAttribute('href').replace("desktop", "mobile").replace("tab","accordion");
              var tabEl = document.querySelector(tabId);
              var accEl = document.querySelector(accID);
              
              if(tabEl) {

                var customDefaultTabsContentEl = document.querySelector('.what_it_is_customDefaultTabsContent');
                if(customDefaultTabsContentEl)  {
                  customDefaultTabsContentEl.innerHTML = tabEl.innerHTML;
                }
                tabEl.innerHTML = isActiveCustomTab_WhatItIs_El.innerHTML;
                 if(accEl) {
                         accEl.innerHTML = isActiveCustomTab_WhatItIs_El.innerHTML;
                       }
                defaultTab_Ingredients_Text = false;
              } 
            }
          });
        }
        clearInterval(timerId);
      }
    },1000);
    }
  }

});                          